import { useState } from "react";
import SalesPerformance from "./Salesperformance";
import SalesCharts from "./SalesCharts";
import FormAside from "./FormAside";
import "./Salesperformance.css";
import FormNotification from "./FormNotification";


function SalesperformanceDashboard() {

    const [viewPage, setViewPage] = useState(false);

    const handlePage = () => {
        setViewPage(prev => !prev)
    }
    return (
        <div className="mainBlock sales-performance-dashboard-container">
            <FormNotification />
            <FormAside />
             {viewPage ?
              <button onClick={handlePage} className="GoBack">Go Back</button>
             :<button onClick={handlePage} className="Addnew">Add new</button>  
            }

            {viewPage ? <SalesPerformance /> : <SalesCharts />}
           

        </div>
    )

}
export default SalesperformanceDashboard;